import Repository from '../../../Repository';

const resource = '/kitsilano/orders/status';

export default {
  fetch(params) {
    return Repository.get(resource, {params});
  },
};
